import CoralPageHeader from '@seaweb/coral/components/PageHeader';
import styled from 'styled-components';

const PageHeader = styled(CoralPageHeader)``;

export default PageHeader;
